module.exports = __webpack_public_path__ + "static/media/Header.26496154.jpg";